const monkaiCustom = {
  'code[class*="language-"]': {
    color: '#f8f8f2',
    background: 'none',
    textShadow: '0 1px rgba(0, 0, 0, 0.3)',
    fontFamily: 'Menlo, Monaco, \'Courier New\', monospace',
    fontSize: '16px',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    wordWrap: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
  },
  'pre[class*="language-"]': {
    color: '#f8f8f2',
    background: '#0c1011',
    textShadow: '0 1px rgba(0, 0, 0, 0.3)',
    fontFamily: 'Menlo, Monaco, \'Courier New\', monospace',
    fontSize: '16px',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    wordWrap: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
    padding: '1em',
    margin: '.5em 0',
    overflow: 'auto',
    borderRadius: '0.3em',
  },
  ':not(pre) > code[class*="language-"]': {
    background: '#0c1011',
    padding: '.1em',
    borderRadius: '.3em',
    whiteSpace: 'normal',
  },
  comment: {
    color: '#677A83',
  },
  prolog: {
    color: '#6272a4',
  },
  doctype: {
    color: '#6272a4',
  },
  cdata: {
    color: '#6272a4',
  },
  punctuation: {
    // color: '#E6DB74',
    color: '#ffffff',
  },
  '.namespace': {
    Opacity: '.7',
  },
  // Property refers to the key in a JSON FIle
  property: {
    color: '#57abe6',
    fontStyle: 'italic',
  },
  tag: {
    color: '#F92672',
  },
  constant: {
    color: '#AE81FF',
  },
  symbol: {
    color: '#AE81FF',
  },
  deleted: {
    color: '#AE81FF',
  },
  boolean: {
    color: '#b67fff',
  },
  number: {
    color: '#b67fff',
  },
  selector: {
    color: '#94e400',
  },
  'attr-name': {
    color: '#A6E22E',
  },
  string: {
    color: '#E6DB74',
  },
  char: {
    color: '#AE81FF',
  },
  builtin: {
    color: '#AE81FF',
  },
  inserted: {
    color: '#AE81FF',
  },
  operator: {
    color: '#f8f8f2',
  },
  entity: {
    color: '#f8f8f2',
    cursor: 'help',
  },
  url: {
    color: '#f8f8f2',
  },
  '.language-css .token.string': {
    color: '#f8f8f2',
  },
  '.token.unit': {
    color: '#ff0071',
  },
  '.token.hexcode.color': {
    color: '#b67fff',
  },
  '.style .token.string': {
    color: '#f8f8f2',
  },
  variable: {
    color: '#f8f8f2',
  },
  atrule: {
    color: '#A6E22E',
  },
  'attr-value': {
    color: '#E6DB74',
  },
  function: {
    color: '#94e400',
  },
  'function-name': {
    color: '#94e400',
  },
  'class-name': {
    color: '#13dcf3',
    fontDecoration: 'underline',
  },
  'maybe-class-name': {
    color: '#13dcf2',
  },
  keyword: {
    // color: '#F92672',
    color: '#13dcf2',
  },
  regex: {
    color: '#ffb86c',
  },
  important: {
    color: '#ffb86c',
    fontWeight: 'bold',
  },
  bold: {
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
}

export default monkaiCustom
